
export default {
  'order': {
    'title': '下订单',
    'subTitle': '展商会收到您的意向订单，与您联系洽谈',
    'number': '填写数量',
    'remarks': '备注',
    'numberPlaceholder': '请输入采购数量',
    'remarksPlaceholder': '请输入您还想了解的事项',
    'employeePlaceholder': '请选择展商负责人',
    'all order': '全部订单',
    'my order': '我的订单',
    'all': '全部',
    'not assigned': '未分配人员（{0}）',
    'already assigned': '已分配人员（{0}）',
    'me': '我的',
    'Cancel': '取消',
    'Confirm': '确认',
    'Potential Order Management': '意向订单管理',
  },
  'Chat': '联系',
  'Amount purchased': '采购量',
  'Potential Amount purchased': '意向采购量: {0}',
  'Action': '操作',
  'Follow up person': '跟进人员',
  'Potential Order': '意向订单',
  'Order Completed': '已联系',
  'Not completed yet': '未联系',
  'Order time': '下单时间',
  'Search by exibitor name, exibits': '通过展商、展品名称搜索',
  'Results are shown by Beijing Time (GMT+8)': '以下显示为北京时间（GMT+8）',
  'Delete': '删除',
  'Contact': '联系',
  'Are you sure you want to delete this order?': '您确定删除此订单吗？',
  'Assign salesman': '分配业务员',
  'You can chat with potential customer by assigning salesman, managing your potential order': '分配的业务员可以和订单意向客商进行沟通，管理意向订单',
  'Enter salesman name for searching': '输入业务人员姓名搜索',
  'Assign employee': '分配人员',
  'Salesman not assigned': '未分配人员',
  'Salesman already assigned': '已分配人员',
  'You selected': '您已选择',
  'Potential order detail': '意向订单详情',
  'Record the data and status for the current order detail': '记录当前订单详细的数据信息和状态',
  'Submit potential order successfully': '提交意向订单成功',
  'Exhibitor\'s Salesman': '展商员工',
  'Not assigned yet': '暂未分配',
  'Delete potential order successfully': '订单删除成功',
  'Complete order': '完成订单',
  'Wish Product': '意向展品',
  'Wish Exhibitor': '意向展商',
  'Order Employee': '员工',
  'Search by visitor name, exibits': '通过客商、展品名称搜索',
  'Export': '导出',
  'Select salesman': '选择负责人',
  'Exhibitor Employee': '展商员工',
  'Select again': '重新选择',
  'Contact status': '联系状态',
  'Search employee': '搜索员工',
  'Please enter a number value': '请输入一个真实的数字',
  'Amount should less than 99999': '数量需小于99999'
}
